export default "__VITE_ASSET__BKUvG$_k__"